module.exports = __webpack_public_path__ + "static/4.2_1440x280_Desktop_gradient_1X-570e16df55207e5765a68525f203eaf1.png";